import { combineReducers } from 'redux';
import posts from './post.js';

export default combineReducers({posts});